import { ElementRef } from "@angular/core";

export class EvalDealerPersonalizationConfig {
    id: string;
    name: string;
    templateDefault: boolean;
    evalDealersIds: string[];
    primaryColor: string;
    buttonColor: string;
    buttonHoverColor: string;
    logoUrl: string;
    raioXLogoUrl: string;
    evaluationLogoUrl: string;
    heroImageUrl: string;
    homeTitle: string;
    homeSubtitle: string;
    homeTitleSubtitleColor: string;
    evaluationHeroImageUrl: string;
    evaluationHomeTitle: string;
    evaluationHomeSubtitle: string;
    evaluationHomeTitleSubtitleColor: string;
    disabled: boolean;
    disabledRaioX: boolean;
    oemDealerId: string;
    whatsAppNumber: string;
    whatsAppMessage: string;
    hideReasonField: boolean;
    mandatoryCpf: boolean;
    alternativeDomain: string;
    allowEvalScheduler: boolean;
    exitUrl: string;
    exitLabel: string;
    personalizedTermsCTA: string;
    personalizedTermsUrl: string;
    footerLinkText: string;
    footerLinkUrl: string;
    contactInfo: string;
    blockConfirmationEmail: boolean;
    colorContents: string;
    offerColor: string;
    sendEmailToSellers: boolean;
    chooseEvalDealer: boolean;
}

export class EvalDealerPersonalizationConfigUtils {

    static initCssVars(elRef: ElementRef, sellerDetails: EvalDealerPersonalizationConfig, evalOnline: boolean): void {
        this.setCssVar(elRef, '--primary-color', sellerDetails.primaryColor);
        this.setCssVar(elRef, '--button-hover-color', sellerDetails.buttonHoverColor);
        this.setCssVar(elRef, '--button-color', sellerDetails.buttonColor);
        if (evalOnline) {
            this.setCssVar(elRef, '--layout-bg-color', sellerDetails.offerColor);
            this.setCssVar(elRef, '--title-subtitle-color', sellerDetails.evaluationHomeTitleSubtitleColor);
            this.setCssVar(elRef, '--title-color', sellerDetails.evaluationHomeTitleSubtitleColor);
            if (sellerDetails.evaluationHeroImageUrl) {
                this.setCssVar(elRef, '--hero-image-url', `url("${sellerDetails.evaluationHeroImageUrl}")`);
            }
        }
        else {
            this.setCssVar(elRef, '--title-subtitle-color', sellerDetails.homeTitleSubtitleColor);
            this.setCssVar(elRef, '--title-color', sellerDetails.homeTitleSubtitleColor);
            if (sellerDetails.heroImageUrl) {
                this.setCssVar(elRef, '--hero-image-url', `url("${sellerDetails.heroImageUrl}")`);
            }
        }
        this.setCssVar(elRef, '--color-contents', sellerDetails.colorContents !== undefined && sellerDetails.colorContents !== "" ? sellerDetails.colorContents : '#fff');
        this.setCssVar(elRef, '--offer-color', sellerDetails.offerColor !== undefined && sellerDetails.offerColor !== "" ? sellerDetails.offerColor : '#16b097');
        
    }


    static setCssVar(elRef: ElementRef, varName: string, value: string) {
        if (value) {
            elRef.nativeElement.style.setProperty(varName, value);
        }
    }
}